

<app-navbar-style-two></app-navbar-style-two>

<div class="navbar-area fixed-nav">
    <nav class="navbar navbar-expand-lg navbar-light ">
      <div class="container-fluid">
        <a routerLink="/" class="navbar-brand"> <img ngSrc="https://medeilpos.blob.core.windows.net/websiteimage/hq-logo.webp" alt="medeilcloud hq image" height="52" width="160"  priority></a>
            <button class="navbar-toggler" type="button" data-bs-toggle="collapse" data-bs-target="#navbarNavDropdown" aria-controls="navbarNavDropdown" aria-expanded="false" aria-label="Toggle navigation">
                <span class="navbar-toggler-icon"></span>
            </button>
        <div class="collapse navbar-collapse" id="navbarNavDropdown">
                <ul class="navbar-nav">
                    <li class="nav-item">
                        <a i18n class="nav-link inter-item">Feature</a>
                    </li>
                    <li class="nav-item">
                        <a i18n  class="nav-link" >FAQ</a>
                    </li>
                    <li class="nav-item">
                        <a i18n class="nav-link">Testimonials</a>
                    </li>
                    <li class="nav-item">
                        <a i18n class="nav-link" routerLink="/medeil-hq-pricing">Price</a>
                    </li>
                    <li class="nav-item">
                        <a i18n class="nav-link" routerLink="/free-software-download">Login/SignUp</a>
                    </li>
                </ul>
        </div>
      </div>
    </nav>
</div>

<section class="banner">
    <div class="banner-content">
      <h1 i18n>MEDEIL Cloud HQ – Centralized POS for Retail & Pharmacy Chains</h1>
      <!-- <p i18n>Streamline Multi-Store Management with Real-Time Insights and Centralized Control.</p> -->
        <div class="button-container">
            <button i18n type="button" class="default-btn3" (click)="appointment('Medeil Cloud Hq')">Request a Free Demo</button>
        </div>
    </div>
    <video src="https://medeilpos.blob.core.windows.net/websiteimage/medeil-cloud-hq.mp4" autoplay loop muted></video>
</section>

<ngx-smart-modal #enquirypos identifier="enquirypos" [closable]="false">

    <div class="custom-modal">
       <button class="close-btn" (click)="closeModal()">X</button>
       <div class="modal-header">
           <h5 i18n class="modal-title" id="exampleModalLabel">Enquiry Form</h5>
       </div>
         <div class="modal-body">
           <form [formGroup]="enquiryForm">
             <div class="form-group">
               <label i18n for="recipient-name" class="col-form-label"><strong>Name</strong><span class="star">*</span></label>
               <input type="text" name="rec" class="form-control" id="recipient-name" formControlName="leadname" required>
             </div>
             <div class="form-group">
               <label i18n for="message-text" class="col-form-label"><strong>Organisation</strong></label>
               <input type="text" name="rec" class="form-control" id="recipient-name" formControlName="organizationname" required>
             </div>
             <div class="form-group">
               <label for="message-text" class="col-form-label"><strong>Email</strong><span class="star">*</span></label>
               <input type="text" name="rec" class="form-control" id="recipient-name" formControlName="primaryemail" required>
               <div *ngIf="enquiryForm.controls.primaryemail.invalid && (enquiryForm.controls.primaryemail.dirty || enquiryForm.controls.primaryemail.touched)">
                <div i18n *ngIf="enquiryForm.controls.primaryemail.errors?.required" style="color: red;">Email is required.</div>
                <div i18n *ngIf="enquiryForm.controls.primaryemail.errors?.pattern" style="color: red;">Invalid email format.</div>
              </div>
             </div>
             <div class="form-group">
               <label i18n for="message-text" class="col-form-label"><strong>Country</strong></label>
               <select class="form-control"  formControlName="countryname1" style="font-size: 12px;" (change)="countrychange()">
                <option i18n select disabled value="0" >---Select Country---</option>
                <option  value="{{ country[1] }}" *ngFor="let country of totalcountry">{{country[1]}}</option>

              </select>
             </div>
             <div class="form-group">
               <label i18n for="message-text" class="col-form-label"><strong>Mobile</strong><span class="star">*</span></label>
               <div class="row">
                 <div class="col-lg-3">
                   <input type="text" name="rec" readonly class="form-control mobile-field" [(ngModel)]="dialcode" id="recipient-name" formControlName="phonedialcode">
                 </div>
                 <div class="col-lg-9">
                   <input type="text" name="rec" class="form-control mobile-field" maxlength="15" id="recipient-name" formControlName="primaryphone"
                   autocomplete="off" oninput="this.value = this.value.replace(/[^0-9.]/g, '').replace(/(\..*)\./g, '$1')">
                 </div>
               </div>

             </div>
             <div class="form-group">
               <label i18n for="message-text" class="col-form-label"><strong>Description</strong></label>
               <input type="text" name="rec" class="form-control" id="recipient-name" formControlName="address1">
             </div>

             <label i18n for="message-text" class="col-form-label captchalabel"><strong>Enter captcha</strong></label>
             <div class="input-group">
                <input type="text" class="form-control ecaptcha" required formControlName="enteredcaptcha" required="required"
                 (change)="checkCaptcha()"/>
                <input type="text" class="form-control gcaptcha" formControlName="generatedcaptcha" readonly
                [(ngModel)]="captcha"/>
                <i class="fa fa-arrows-rotate refresh" (click)="generatecaptcha()"></i>
              </div>
              <div *ngIf="ecaptcha">
                <p style="color: red">{{ errorcaptcha }}</p>
              </div>
             <div class="form-group">

                   <label i18n class="container1 mt-3">I Accept Terms & Conditions & MEDEIL Privacy Policy – Your Data Security & Rights
                       <input type="checkbox" checked="checked" formControlName="checkbox">
                       <span class="checkmark"></span>
                   </label>
             </div>
             <div class="btn-group mt-3" *ngIf="!showElement">
               <button i18n type="button" class="enquiry-btn" (click)="submitenquery()" >Submit</button>

             </div>


           </form>
         </div>
    </div>
</ngx-smart-modal>

<ngx-smart-modal #appointmentform identifier="appointmentform" [closable]="false">


    <div class="custom-modal"  >
       <button class="close-btn" (click)="closeModal()">X</button>
        <div class="modal-header-appointment">
            <h4 i18n class="modal-title" id="exampleModalLabel">Demo Request</h4>
        </div>
          <div class="modal-body">

             <div class="row">
                <div class="col-lg-12">
                   <mat-form-field >

                      <input matInput [matDatepicker]="picker" placeholder="Choose a date" (dateChange)="slectdate($event)" >
                      <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
                      <mat-datepicker #picker></mat-datepicker>
                   </mat-form-field>

                </div>
                <div  align="center" *ngIf="showElement">
                   <img height="200px" width="200px" src="https://medeilpos.blob.core.windows.net/posimage/loading.gif" alt="medeil gif" loading="lazy">
                 </div>
                <div class="col-lg-12" *ngIf="appointment_time">

                    <div class="button-container">
                      <button class="flex-button" *ngFor="let time of timeSlots" (click)="selectTime(time)" [ngClass]="{ 'clicked': selectedTime === time }">{{ time }}</button>
                  </div>
                  <div  align="center" *ngIf="showElementsave">
                    <img height="100px" width="100px" src="https://medeilpos.blob.core.windows.net/posimage/loading.gif" alt="medeil gif" loading="lazy">
                  </div>
                    <div class="shedule-submit">
                      <button i18n class="shedulebtn" (click)="savelead()">Submit</button>
                    </div>
                </div>
             </div>

          </div>
    </div>
</ngx-smart-modal>

<br>
<div class="container-md p-5 box-container">
    <p i18n style="color:white">Take control of your entire retail or pharmacy chain with MEDEIL Cloud HQ, the ultimate multi-store POS management solution. Designed for growing businesses, MEDEIL Cloud HQ offers centralized POS operations, advanced analytics, and seamless inventory control—empowering you to manage all your locations from a single, intuitive platform.</p>
</div>
<br>

<div class="newslider" >

    <div class="place-list-item">
        <img ngSrc="https://medeilpos.blob.core.windows.net/websiteimage/anu-pharmacy.webp" width="300" height="200" priority alt="medeil client image for anu-pharmacy">
    </div>

    <div class="place-list-item">
        <img ngSrc="https://medeilpos.blob.core.windows.net/websiteimage/apollo-hospitals.webp" width="300" height="200" priority  alt="medeil client image for apollo-hospitals"  >
    </div>

    <div class="place-list-item">
        <img ngSrc="https://medeilpos.blob.core.windows.net/websiteimage/bellamed-healthcare.webp" width="300" height="200" priority  alt="medeil client image for bellamed-healthcare" >
    </div>

    <div class="place-list-item">
        <img ngSrc="https://medeilpos.blob.core.windows.net/websiteimage/bk-heart-hospital.webp"   alt="medeil client image for bk-heart-hospital" width="300" height="200" priority>
    </div>

    <div class="place-list-item">
        <img ngSrc="https://medeilpos.blob.core.windows.net/websiteimage/booncholai-super-market.webp"   alt="medeil client image for booncholai-super-market" width="300" height="200" priority>
    </div>

    <div class="place-list-item">
        <img ngSrc="https://medeilpos.blob.core.windows.net/websiteimage/emedsure.webp"   alt="medeil client image for emedsure" width="300" height="200" priority>
    </div>

    <div class="place-list-item">
        <img ngSrc="https://medeilpos.blob.core.windows.net/websiteimage/express-pharmacy.webp"    alt="medeil client image for express-pharmacy" width="300" height="200" priority>
    </div>

    <div class="place-list-item">
        <img ngSrc="https://medeilpos.blob.core.windows.net/websiteimage/falcon-healthcare.webp"    alt="medeil client image for falcon-healthcare" width="300" height="200" priority>
    </div>

    <div class="place-list-item">
        <img ngSrc="https://medeilpos.blob.core.windows.net/websiteimage/global-bridge-pharmaceutical.webp"   alt="medeil client image for global-bridge-pharmaceutical" width="300" height="200" priority>
    </div>

    <div class="place-list-item">
        <img ngSrc="https://medeilpos.blob.core.windows.net/websiteimage/hawi-family-hostpital.webp"   alt="medeil client image for hawi-family-hostpital" width="300" height="200" priority>
    </div>

    <div class="place-list-item">
        <img ngSrc="https://medeilpos.blob.core.windows.net/websiteimage/henry-jackson-foundation.webp"   alt="medeil client image for henry-jackson-foundation" width="300" height="200" priority>
    </div>

    <div class="place-list-item">
        <img ngSrc="https://medeilpos.blob.core.windows.net/websiteimage/imcri.webp"   alt="medeil client image for imcri" width="300" height="200" priority>
    </div>

</div>

<section class="info-section">
    <div class="container2">
        <div class="feature-box">
            <h3 i18n class="feature-title">Why Choose MedeilCloud HQ?</h3>
            <p i18n class="feature-description">
                MedeilCloud HQ offers a comprehensive suite of features designed to streamline your multi-store management. From real-time analytics to centralized inventory control, our solution empowers you to make data-driven decisions that enhance operational performance.
            </p>
        </div>
        <div class="text-content">
            <h2 i18n class="title">Centralized Inventory and Stock Control</h2>
            <p i18n class="description">
                Streamline your inventory management with centralized stock control. MEDEIL Cloud HQ enables you to track inventory levels, transfers, and replenishments across all locations. Reduce stockouts, prevent overstocking, and ensure every store is fully equipped to meet customer demand.            </p>
        </div>
    </div>
</section>

<section class="info-section">
    <div class="container2">
        <div class="text-content">
            <h2 i18n class="title">Manage Multiple Stores from One Dashboard</h2>
            <p i18n class="description">
                With MEDEIL Cloud HQ, you can oversee every retail or pharmacy location from one centralized dashboard. Our multi-store POS system simplifies retail chain management, allowing you to monitor sales, staff, and performance across all branches in real time. Whether you operate a handful of stores or a large network, MEDEIL Cloud HQ scales with your business.            </p>
        </div>

        <div class="feature-box">
            <h3 i18n class="feature-title">Advanced Analytics and Real-Time Reporting</h3>
            <p i18n class="feature-description">
                Unlock powerful insights with MEDEIL Cloud HQ’s advanced POS analytics. Access real-time reporting on sales, inventory, and customer trends across your entire chain. Make data-driven decisions to optimize operations, boost profitability, and stay ahead of the competition.            </p>
        </div>


    </div>
</section>



<ngx-smart-modal #myModal identifier="myModal" [closable]="false">

    <div class="custom-modal">
        <button class="close-btn" (click)="closepopup()">X</button>
        <div class="modal-header">
            <h5 i18n class="modal-title" id="exampleModalLabel">Enquiry Form</h5>
        </div>
        <div class="modal-body">
         <form [formGroup]="enquiryForm">
           <div class="form-group">
             <label i18n for="recipient-name" class="col-form-label"><strong>Name</strong><span class="star">*</span></label>
             <input type="text" name="rec" class="form-control" id="recipient-name" formControlName="leadname" required>
           </div>
           <div class="form-group">
             <label i18n for="message-text" class="col-form-label"><strong>Organisation</strong></label>
             <input type="text" name="rec" class="form-control" id="recipient-name" formControlName="organizationname" required>
           </div>
           <div class="form-group">
             <label for="message-text" class="col-form-label"><strong>Email</strong><span class="star">*</span></label>
             <input type="text" name="rec" class="form-control" id="recipient-name" formControlName="primaryemail" required>
             <div *ngIf="enquiryForm.controls.primaryemail.invalid && (enquiryForm.controls.primaryemail.dirty || enquiryForm.controls.primaryemail.touched)">
              <div i18n *ngIf="enquiryForm.controls.primaryemail.errors?.required" style="color: red;">Email is required.</div>
              <div i18n *ngIf="enquiryForm.controls.primaryemail.errors?.pattern" style="color: red;">Invalid email format.</div>
            </div>
           </div>
           <div class="form-group">
             <label i18n for="message-text" class="col-form-label"><strong>Country</strong></label>
             <select class="form-control"  formControlName="countryname1" style="font-size: 13px;" (change)="countrychange()">
              <option i18n select disabled value="0" >---Select Country---</option>
              <option  value="{{ country[1] }}" *ngFor="let country of totalcountry">{{country[1]}}</option>
            </select>
           </div>
           <div class="form-group">
             <label i18n for="message-text" class="col-form-label"><strong>Mobile</strong><span class="star">*</span></label>
             <div class="row">
               <div class="col-lg-3">
                 <input type="text" name="rec" readonly class="form-control mobile-field" [(ngModel)]="dialcode" id="recipient-name" formControlName="phonedialcode">
               </div>
               <div class="col-lg-9">
                 <input type="text" name="rec" class="form-control mobile-field" maxlength="15" id="recipient-name" formControlName="primaryphone"
                 autocomplete="off" oninput="this.value = this.value.replace(/[^0-9.]/g, '').replace(/(\..*)\./g, '$1')">
               </div>
             </div>

           </div>
           <div class="form-group">
             <label i18n for="message-text" class="col-form-label"><strong>Description</strong></label>
             <input type="text" name="rec" class="form-control" id="recipient-name" formControlName="address1">
           </div>
           <label i18n for="message-text" class="col-form-label captchalabel"><strong>Enter captcha</strong></label>
           <div class="input-group">
              <input type="text" class="form-control ecaptcha" required formControlName="enteredcaptcha" required="required"
               (change)="checkCaptcha()"/>
              <input type="text" class="form-control gcaptcha" formControlName="generatedcaptcha" readonly
              [(ngModel)]="captcha"/>
              <i class="fa fa-arrows-rotate refresh" (click)="generatecaptcha()"></i>
            </div>
            <div *ngIf="ecaptcha">
              <p style="color: red">{{ errorcaptcha }}</p>
            </div>
           <div class="form-group">
                 <label i18n class="container1 mt-3">I Accept Terms & Conditions & MEDEIL Privacy Policy – Your Data Security & Rights
                     <input type="checkbox" checked="checked" formControlName="checkbox">
                     <span class="checkmark"></span>
                 </label>
           </div>
           <div  align="center" *ngIf="showElement">
            <img height="50px" width="50px" src="https://medeilpos.blob.core.windows.net/posimage/loading.gif" alt="medeil gif" loading="lazy">
          </div>
           <div class="btn-group mt-3">
             <button i18n type="button" class="enquiry-btn" (click)="savesignup()">Submit</button>
           </div>
         </form>
       </div>
    </div>

</ngx-smart-modal>
<section class="category-area pb-50 " id="Vertical">
    <div class="container mt-4">
        <div class="section-title gradient-text" >
            <h2 i18n>Vertical</h2>
        </div>
        <div class="row pt-45 newfeature" style="justify-content: left !important;" >
            <div class="col-lg-3">
                <div class="category-box" routerLink="/industry/pharmacy-management-software" >

                   <svg viewBox="0 0 512 512" xmlns="http://www.w3.org/2000/svg" width="100px" height="100px"><g id="Medicine_pill"><path d="M428.1377,202.7671a30.5211,30.5211,0,0,1-15.834-26.7578V160.8022h8.5742a24.2913,24.2913,0,0,0,24.2637-24.2636V87.8853a24.2913,24.2913,0,0,0-24.2637-24.2637H243.3057A24.2913,24.2913,0,0,0,219.042,87.8853v48.6533a24.2913,24.2913,0,0,0,24.2637,24.2636H251.88v15.2071a30.5211,30.5211,0,0,1-15.834,26.7578,71.1637,71.1637,0,0,0-36.917,62.3867V407.5864a40.8377,40.8377,0,0,0,40.792,40.792H424.2627a40.8377,40.8377,0,0,0,40.792-40.792V265.1538A71.1637,71.1637,0,0,0,428.1377,202.7671ZM243.3057,75.6216h18.4209v27.4678a6,6,0,1,0,12,0V75.6216h30.206v27.4678a6,6,0,1,0,12,0V75.6216h30.2061v27.4678a6,6,0,1,0,12,0V75.6216h30.206v27.4678a6,6,0,1,0,12,0V75.6216h20.5332a12.2782,12.2782,0,0,1,12.2637,12.2637v42.1871h-202.1V87.8853A12.2781,12.2781,0,0,1,243.3057,75.6216Zm209.749,331.9648a28.8246,28.8246,0,0,1-28.792,28.792H239.9209a28.8246,28.8246,0,0,1-28.792-28.792V265.1538a59.1659,59.1659,0,0,1,30.6924-51.8682A42.519,42.519,0,0,0,263.88,176.0093V160.8022H400.3037v15.2071a42.5218,42.5218,0,0,0,22.0586,37.2773,59.1634,59.1634,0,0,1,30.6924,51.8672Z"/><path d="M395.6172,247.2192H268.5664a25.6513,25.6513,0,0,0-25.6221,25.6221V367.228A25.6513,25.6513,0,0,0,268.5664,392.85H395.6172a25.6513,25.6513,0,0,0,25.6221-25.6221V272.8413A25.6513,25.6513,0,0,0,395.6172,247.2192ZM409.2393,367.228A13.637,13.637,0,0,1,395.6172,380.85H268.5664a13.637,13.637,0,0,1-13.6221-13.6221V272.8413a13.637,13.637,0,0,1,13.6221-13.6221H395.6172a13.637,13.637,0,0,1,13.6221,13.6221Z"/><path d="M383.9878,274.6555H280.1958a9.0335,9.0335,0,0,0-9.0334,9.0333v73.0257a9.0334,9.0334,0,0,0,9.0334,9.0333h103.792a9.0334,9.0334,0,0,0,9.0334-9.0333V283.6888A9.0335,9.0335,0,0,0,383.9878,274.6555ZM349.02,325.9536H338.0918v10.9277a6,6,0,0,1-12,0V325.9536H315.1631a6,6,0,0,1,0-12h10.9287V303.0249a6,6,0,0,1,12,0v10.9287H349.02a6,6,0,0,1,0,12Z"/><path d="M110.335,224.56a53.37,53.37,0,0,0-53.31,53.3095V389.9253a53.31,53.31,0,1,0,106.6191,0V277.87A53.37,53.37,0,0,0,110.335,224.56Zm0,206.6748a41.3562,41.3562,0,0,1-41.31-41.31V336.66h82.6191v53.265A41.3562,41.3562,0,0,1,110.335,431.2349Z"/><path d="M110.335,64.0229a63.39,63.39,0,1,0,63.3906,63.3907A63.4618,63.4618,0,0,0,110.335,64.0229ZM59.3071,130.0724v-2.3609A51.673,51.673,0,0,1,78.8893,86.799a51.27,51.27,0,0,1,62.8919,0,51.6727,51.6727,0,0,1,19.5826,40.9128v2.3607Z"/></g></svg>
                    <a i18n><h3>Pharmacies</h3></a>
                </div>
            </div>
            <div class="col-lg-3" >
                <div class="category-box"  routerLink="/industry/optical-store-management">

                    <svg height="24" viewBox="0 0 24 24" width="100px" height="100px" xmlns="http://www.w3.org/2000/svg"><path d="M1,13 C0.44771525,13 0,12.5522847 0,12 C0,11.4477153 0.44771525,11 1,11 L1.41604369,11 C2.18760031,9.23409522 3.94968096,8 6,8 C7.82440303,8 9.42058775,8.97711876 10.2937745,10.4365766 C10.7845275,10.1580384 11.3764731,10 12,10 C12.6235269,10 13.2154725,10.1580384 13.7062255,10.4365766 C14.5794122,8.97711876 16.175597,8 18,8 C20.050319,8 21.8123997,9.23409522 22.5839563,11 L23,11 C23.5522847,11 24,11.4477153 24,12 C24,12.5522847 23.5522847,13 23,13 C23,15.7614237 20.7614237,18 18,18 C15.2385763,18 13,15.7614237 13,13 C13,12.8312503 13.0083597,12.6644531 13.0246876,12.5 L13,12.5 C13,12.2965729 12.6045695,12 12,12 C11.3954305,12 11,12.2965729 11,12.5 L10.9753124,12.5 C10.9916403,12.6644531 11,12.8312503 11,13 C11,15.7614237 8.76142375,18 6,18 C3.23857625,18 1,15.7614237 1,13 Z M6,16 C7.65685425,16 9,14.6568542 9,13 C9,11.3431458 7.65685425,10 6,10 C4.34314575,10 3,11.3431458 3,13 C3,14.6568542 4.34314575,16 6,16 Z M18,16 C19.6568542,16 21,14.6568542 21,13 C21,11.3431458 19.6568542,10 18,10 C16.3431458,10 15,11.3431458 15,13 C15,14.6568542 16.3431458,16 18,16 Z" fill-rule="evenodd"/></svg>
                    <a i18n><h3>Optical</h3></a>
                </div>
            </div>
            <div class="col-lg-3">
                <div class="category-box"  routerLink="/industry/medical-store-software">

                    <svg viewBox="0 0 512 512" xmlns="http://www.w3.org/2000/svg" width="100px" height="100px"><g id="Safe_excercise_health_care"><path d="M445.4326,370.6182H442.32v-22.773a15.74,15.74,0,0,0-15.74-15.74H407.6726a15.6768,15.6768,0,0,0-3.7393.4675v-1.3674a15.7392,15.7392,0,0,0-15.7392-15.7393H369.2859a15.7393,15.7393,0,0,0-15.7393,15.7393v40.1558a3.2786,3.2786,0,0,1-3.2787,3.2786H162.7813a3.2786,3.2786,0,0,1-3.2787-3.2786V331.2056a15.7392,15.7392,0,0,0-15.7392-15.7393H124.8552a15.7393,15.7393,0,0,0-15.7393,15.7393v1.3674a15.676,15.676,0,0,0-3.7392-.4675H86.4685a15.7392,15.7392,0,0,0-15.7393,15.7392v22.7735h-3.112c-14.8542,0-27.4262,11.6244-27.8669,26.4721a27.3277,27.3277,0,0,0,27.2856,28.1241h3.6933V449.53A15.7392,15.7392,0,0,0,86.4685,465.269h18.9082a15.6709,15.6709,0,0,0,3.7392-.4675v1.3674a15.7393,15.7393,0,0,0,15.7393,15.7393h18.9082a15.7392,15.7392,0,0,0,15.7392-15.7393v-41.2a3.2787,3.2787,0,0,1,3.2787-3.2787H350.2679a3.2787,3.2787,0,0,1,3.2787,3.2787v41.2a15.7393,15.7393,0,0,0,15.7393,15.7393h18.9082a15.7392,15.7392,0,0,0,15.7392-15.7393v-1.3674a15.6717,15.6717,0,0,0,3.7393.4675h18.9082A15.7392,15.7392,0,0,0,442.32,449.53V425.2144h3.6934A27.3282,27.3282,0,0,0,473.299,397.09C472.8581,382.2424,460.2864,370.6182,445.4326,370.6182ZM109.1159,449.53a3.7435,3.7435,0,0,1-3.7392,3.7392H86.4685a3.7435,3.7435,0,0,1-3.7393-3.7392V347.8452a3.744,3.744,0,0,1,3.7393-3.74h18.9082a3.7439,3.7439,0,0,1,3.7392,3.74Zm38.3867,16.6391a3.7435,3.7435,0,0,1-3.7392,3.7393H124.8552a3.7436,3.7436,0,0,1-3.7393-3.7393V331.2056a3.7437,3.7437,0,0,1,3.7393-3.7393h18.9082a3.7436,3.7436,0,0,1,3.7392,3.7393ZM391.9333,347.8452V466.1689a3.7435,3.7435,0,0,1-3.7392,3.7393H369.2859a3.7435,3.7435,0,0,1-3.7393-3.7393V331.2056a3.7436,3.7436,0,0,1,3.7393-3.7393h18.9082a3.7436,3.7436,0,0,1,3.7392,3.7393Zm38.3867,28.773V449.53a3.7435,3.7435,0,0,1-3.7392,3.7392H407.6726a3.7435,3.7435,0,0,1-3.7393-3.7392V347.8452a3.744,3.744,0,0,1,3.7393-3.74h18.9082a3.7439,3.7439,0,0,1,3.7392,3.74Z"/><path d="M230.154,299.3677a138.7847,138.7847,0,0,0,25.8721,2.44c65.2578-.001,123.5576-46.4087,136.1484-112.8242a138.6917,138.6917,0,0,0-27.08-111.3188,6,6,0,0,0-9.4492,7.3974,126.21,126.21,0,1,1-19.6377-20.0561,6,6,0,0,0,7.5918-9.293A138.64,138.64,0,1,0,230.154,299.3677Z"/><path d="M338.67,122.5887a23.3585,23.3585,0,0,0-18.0682-21.89A110.1825,110.1825,0,0,1,266.66,70.3666a15.6408,15.6408,0,0,0-22.5174,0A110.1825,110.1825,0,0,1,190.2,100.6986a23.3594,23.3594,0,0,0-18.0681,21.89c-.9265,27.2964,4.4878,95.8355,74.6023,142.6177a15.5749,15.5749,0,0,0,17.3342,0C334.1825,218.4242,339.5968,149.8851,338.67,122.5887Zm-89.2691,129.872c-25.9268-18.307-44.4858-41.59-55.1677-69.2894a154.2719,154.2719,0,0,1-10.1084-60.1753,11.3418,11.3418,0,0,1,8.7937-10.61,122.69,122.69,0,0,0,56.4824-30.3389v20.9644a4.9291,4.9291,0,0,1-2.028,4.0034,140.33,140.33,0,0,1-41.01,20.3821,5.9868,5.9868,0,0,0-4.2331,5.9511c.9731,26.4358,9.7872,63.9445,45.5343,94.9314a4.9875,4.9875,0,0,1,1.7369,3.7635Zm11.5-71.1547a5.5,5.5,0,0,1-11,0V169.2587H237.8538a5.5,5.5,0,0,1,0-11h12.0474V146.2113a5.5,5.5,0,0,1,11,0v12.0474h12.0474a5.5,5.5,0,0,1,0,11H260.9012Zm55.6675,1.8653c-10.6819,27.7-29.2412,50.9824-55.1675,69.29V232.0426a4.9878,4.9878,0,0,1,1.7369-3.7635c35.7469-30.9868,44.5608-68.4953,45.534-94.9309a5.9866,5.9866,0,0,0-4.233-5.9511,140.3312,140.3312,0,0,1-41.01-20.3818,4.93,4.93,0,0,1-2.0281-4.0035V82.0475a122.6928,122.6928,0,0,0,56.4822,30.3386v.0005a11.3405,11.3405,0,0,1,8.7937,10.6094A154.2719,154.2719,0,0,1,316.5687,183.1713Z"/></g></svg>
                    <a i18n><h3>Healthcare stores</h3></a>
                </div>
            </div>
            <div class="col-lg-3">
                <div class="category-box"  routerLink="/industry/beauty-software">

                    <svg enable-background="new 0 0 64 64"  width="100px" height="100px" id="Layer_1" version="1.1" viewBox="0 0 64 64" width="64px" xml:space="preserve" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink"><g><path d="M55.789,18.616c-0.122-0.871-0.943-0.835-0.943-0.835h-0.442c-0.862,0-1.035,1.043-1.065,1.316   c-0.006,0.042-0.006,0.064-0.006,0.064l-0.025-0.006C52.355,30.109,43.202,38.715,32,38.715c-11.061,0-20.133-8.386-21.277-19.142   c-0.011-0.056-0.022-0.105-0.034-0.171c-0.189-1.349-0.79-1.586-1.085-1.621H9.111c-0.663,0-0.852,0.506-0.9,0.883   C8.659,30.89,18.295,40.742,30.427,41.535v11.611L19.617,63.959L19.659,64l24.696-0.018l0.03-0.027L33.573,53.146V41.535   C45.721,40.738,55.363,30.86,55.789,18.616z" fill="#241F20"/><path d="M32.001,0c-9.821,0-17.783,7.96-17.783,17.783c0,9.82,7.962,17.781,17.783,17.781   c9.818,0,17.78-7.961,17.78-17.781C49.781,7.961,41.819,0,32.001,0z M20.391,18.316c0-6.414,5.198-11.61,11.61-11.61   c0.503,0,0.996,0.043,1.483,0.104L21.462,23.166C20.78,21.688,20.391,20.049,20.391,18.316z M26.902,28.736   c-1.009-0.494-1.931-1.129-2.75-1.88L37.811,8.274c0.969,0.562,1.848,1.259,2.614,2.068L26.902,28.736z M32.825,29.885   l10.466-14.237c0.202,0.858,0.32,1.749,0.32,2.669C43.611,24.451,38.852,29.46,32.825,29.885z" fill="#241F20"/></g></svg>
                    <a i18n><h3>Beauty & Cosmetics</h3></a>
                </div>
            </div>
            <div class="col-lg-3" >
                <div class="category-box"  routerLink="/industry/veterinary-software">

                  <svg enable-background="new 0 0 512 512" width="100px" height="100px" version="1.1" viewBox="0 0 512 512" xml:space="preserve" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink"><g id="_x32_4-7_x5F_pet"/><g id="_x32_4-7"><g><path d="M293.512,157.614c-2.102,0-4.213,0.047-6.277,0.139l0.535,11.988c0.197-0.009,0.398-0.012,0.596-0.02v31.972h12V169.8    c65.105,3.47,117.383,56.072,120.342,121.311h-30.924v12h30.91c-3.117,65.088-55.33,117.52-120.328,120.984v-31.566h-12v31.641    c-65.364-2.613-118.202-54.725-121.965-119.791l22.103,22.102l8.484-8.484l-36.342-36.342l-36.343,36.342l8.484,8.486    l21.62-21.619c4.118,73.16,64.933,131.418,139.105,131.418c76.828,0,139.334-62.504,139.334-139.334    C432.846,220.119,370.34,157.614,293.512,157.614z"/><path d="M294.365,320.688c10.605,0,19.582-7.092,22.449-16.781h55.166v-12h-54.832c-1.973-8.369-8.443-15.02-16.715-17.24v-50.609    h-12v50.57c-10.047,2.633-17.482,11.787-17.482,22.648C270.951,310.186,281.455,320.688,294.365,320.688z M288.434,287.545    c1.73-1.061,3.758-1.682,5.932-1.682c2.23,0,4.309,0.652,6.068,1.764c1.674,1.057,3.059,2.529,3.996,4.279    c0.857,1.602,1.348,3.43,1.348,5.369c0,2.475-0.801,4.76-2.143,6.631c-2.072,2.891-5.451,4.781-9.27,4.781    c-6.293,0-11.414-5.119-11.414-11.412C282.951,293.156,285.152,289.551,288.434,287.545z"/><path d="M210.693,267.988c24.593,0,44.601-20.007,44.601-44.6c0-14.489-7.132-28.141-19.077-36.518    c-8.783-6.16-16.712-14.644-23.567-25.214c-8.296-12.791-22.288-20.428-37.43-20.428s-29.134,7.637-37.43,20.428    c-6.854,10.569-14.784,19.053-23.568,25.214c-11.945,8.377-19.077,22.028-19.077,36.518c0,24.593,20.008,44.6,44.601,44.6H210.693    z M107.144,223.388c0-10.581,5.222-20.56,13.968-26.693c10.051-7.05,19.05-16.642,26.746-28.509    c6.074-9.365,16.303-14.957,27.361-14.957s21.287,5.592,27.361,14.957c7.697,11.868,16.695,21.46,26.745,28.509    c8.746,6.134,13.968,16.112,13.968,26.693c0,17.976-14.625,32.601-32.601,32.601h-70.948    C121.769,255.989,107.144,241.364,107.144,223.388z"/><path d="M120.284,153.459v-16.742c0-11.339-9.226-20.564-20.564-20.564s-20.564,9.226-20.564,20.564v16.742    c0,11.339,9.226,20.564,20.564,20.564S120.284,164.798,120.284,153.459z M91.155,153.459v-16.742c0-4.723,3.842-8.564,8.564-8.564    s8.564,3.842,8.564,8.564v16.742c0,4.723-3.842,8.564-8.564,8.564S91.155,158.182,91.155,153.459z"/><path d="M249.904,174.024c11.338,0,20.565-9.226,20.565-20.564v-16.742c0-11.339-9.227-20.564-20.565-20.564    c-11.339,0-20.564,9.226-20.564,20.564v16.742C229.339,164.798,238.565,174.024,249.904,174.024z M241.339,136.717    c0-4.723,3.842-8.564,8.564-8.564s8.565,3.842,8.565,8.564v16.742c0,4.723-3.842,8.564-8.565,8.564s-8.564-3.842-8.564-8.564    V136.717z"/><path d="M147.085,133.589c11.339,0,20.564-9.226,20.564-20.564V96.283c0-11.339-9.226-20.564-20.564-20.564    c-11.34,0-20.565,9.226-20.565,20.564v16.742C126.52,124.364,135.746,133.589,147.085,133.589z M138.52,96.283    c0-4.723,3.843-8.564,8.565-8.564s8.564,3.842,8.564,8.564v16.742c0,4.723-3.842,8.564-8.564,8.564s-8.565-3.842-8.565-8.564    V96.283z"/><path d="M202.538,133.589c11.34,0,20.565-9.226,20.565-20.564V96.283c0-11.339-9.226-20.564-20.565-20.564    c-11.339,0-20.564,9.226-20.564,20.564v16.742C181.973,124.364,191.199,133.589,202.538,133.589z M193.973,96.283    c0-4.723,3.842-8.564,8.564-8.564s8.565,3.842,8.565,8.564v16.742c0,4.723-3.843,8.564-8.565,8.564s-8.564-3.842-8.564-8.564    V96.283z"/></g></g></svg>
                    <a i18n><h3>Veterinary stores</h3></a>
                </div>
            </div>
            <div class="col-lg-3" >
                <div class="category-box"  routerLink="/industry/agriculture-software">

                   <svg id="Layer_1_1_" width="100px" height="100px" style="enable-background:new 0 0 96 96;" version="1.1" viewBox="0 0 96 96" xml:space="preserve" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink"><path d="M38,21.95V34h1h1V21.95C50.578,21.425,59,12.708,59,2C48.629,2,40.105,9.894,39.101,20h-0.202C37.895,9.894,29.371,2,19,2  C19,12.708,27.422,21.425,38,21.95z M55.293,4.293l1.414,1.414l-13,13l-1.414-1.414L55.293,4.293z M35.707,17.293l-1.414,1.414  l-13-13l1.414-1.414L35.707,17.293z"/><rect height="2" width="2" x="90" y="88"/><rect height="2" width="2" x="90" y="92"/><rect height="2" width="2" x="92" y="90"/><rect height="2" width="2" x="88" y="90"/><path d="M38,50.914c-4.556-0.024-8.993-0.209-13.204-0.551c-0.869,3.494-1.364,7.161-1.476,10.932  c4.681,0.433,9.608,0.666,14.68,0.693V50.914z"/><path d="M10.231,59.393c3.342,0.707,7.063,1.279,11.096,1.705c0.119-3.746,0.609-7.409,1.458-10.914  c-3.227-0.306-6.301-0.705-9.178-1.194C11.863,52.145,10.695,55.659,10.231,59.393z"/><path d="M63.278,47.146c-2.596-3.967-6.133-7.26-10.3-9.557c-0.806,0.57-1.754,1.079-2.817,1.52c1.531,2.793,2.779,5.87,3.715,9.187  C57.181,48.009,60.33,47.624,63.278,47.146z"/><path d="M38,41.044c-3.328-0.087-6.418-0.611-8.979-1.489c-1.525,2.698-2.759,5.669-3.692,8.849  c4.044,0.319,8.303,0.488,12.671,0.511V41.044z"/><path d="M14.722,47.146c2.701,0.438,5.57,0.798,8.575,1.076c0.962-3.379,2.256-6.536,3.856-9.412  c-0.789-0.367-1.502-0.776-2.131-1.221C20.855,39.887,17.317,43.18,14.722,47.146z"/><path d="M55.846,64.517c0.753-0.497,1.495-1.021,2.225-1.575c-0.731,0.083-1.455,0.172-2.195,0.245  C55.875,63.647,55.857,64.076,55.846,64.517z"/><path d="M54.383,50.259c0.845,3.523,1.328,7.185,1.442,10.922c1.749-0.175,3.458-0.387,5.136-0.619  c2.19-1.965,4.092-4.037,5.735-6.138c-0.589-1.9-1.357-3.722-2.303-5.434C61.271,49.521,57.912,49.944,54.383,50.259z"/><path d="M58.33,84.612c-6.053,3.283-12.874,5.777-20.079,7.369C38.501,91.987,38.749,92,39,92C46.427,92,53.2,89.204,58.33,84.612z"/><path d="M10,63c0,3.032,0.467,5.955,1.33,8.702c2.991,0.469,6.685,0.888,10.794,1.021c-0.553-3.126-0.846-6.348-0.852-9.619  c-4.07-0.425-7.831-1-11.226-1.709C10.017,61.927,10,62.461,10,63z"/><path d="M24.169,72.764c4.341,0.033,9.055-0.283,13.831-1.206v-7.57c-5.084-0.027-10.023-0.259-14.722-0.69  C23.295,66.523,23.602,69.694,24.169,72.764z"/><path d="M40,71.134c4.693-1.077,9.391-2.778,13.801-5.346c0.039-0.778,0.066-1.575,0.071-2.414  c-4.438,0.383-9.092,0.59-13.872,0.615V71.134z"/><path d="M40,41.044v7.871c4.072-0.022,8.043-0.174,11.84-0.453c-0.914-3.136-2.113-6.044-3.582-8.671  C45.846,40.527,43.02,40.964,40,41.044z"/><path d="M39,39.059c4.71,0,9.065-0.943,11.877-2.513C47.251,34.915,43.234,34,39,34s-8.251,0.915-11.877,2.545  C29.935,38.115,34.29,39.059,39,39.059z"/><path d="M40,61.989c4.769-0.026,9.41-0.233,13.832-0.619c-0.107-3.763-0.596-7.428-1.461-10.941  C48.41,50.73,44.256,50.892,40,50.914V61.989z"/><path d="M60,64C37.992,81.419,5.413,72.798,3,72v18.349c25.252,5.26,55.362-2.214,70-20C83.522,57.564,85.535,42.867,86,36h7L82,18  L71,36h7C76.603,41.25,72.364,54.214,60,64z"/></svg>
                    <a i18n><h3>Agro Stores</h3></a>
                </div>
            </div>
            <div class="col-lg-3" >
                <div class="category-box"  routerLink="/industry/medical-device-software">
                    <svg id="Layer_1" width="100px" height="100px" style="enable-background:new 0 0 48 48;" version="1.1" viewBox="0 0 48 48" xml:space="preserve" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink"><g><path d="M6.6,43l2.8,2.8l0,0l1.5,1.5l1.4-1.4l-1.5-1.5l5.4-5.3l1.5,1.5l0,0l3,2.9l1.4-1.4l-3-2.9l17.7-17.5   c0.6-0.6,0.9-1.3,0.9-2.1c0-0.8-0.3-1.5-0.9-2.1l3.3-3.2L39.5,10l8-8l-1.4-1.4l-8.1,8l-4.4-0.7l-3.3,3.3l0,0c-1.1-1.1-3-1.1-4.2,0   L8.5,28.6l-3-2.9l-1.4,1.4l3,2.9l0,0l1.5,1.5l-5.4,5.3l-1.5-1.5l-1.4,1.4L6.6,43z M34.4,10l3.2,0.5l0.5,3.1l-2.6,2.5L34,14.8   l-2.2-2.2L34.4,10z M27.6,12.5c0.4-0.4,1-0.4,1.3,0l6.5,6.4c0.2,0.2,0.3,0.4,0.3,0.6c0,0.2-0.1,0.5-0.3,0.6L33.7,22l-3.9-3.9   l-1.4,1.4l3.9,3.9l-2.2,2.2l-3.9-3.9l-1.4,1.4l3.9,3.9l-2.2,2.2l-3.9-3.9l-1.4,1.4l3.9,3.9l-2.2,2.2l-3.9-3.9l-1.4,1.4l3.9,3.9   l-3.7,3.6L9.9,30L27.6,12.5z M10,32.9l2.4,2.4l2.4,2.4L9.4,43l-4.8-4.7L10,32.9z"/><path d="M40.7,24.7l-0.8-1.3L39,24.7c-0.7,1.1-7,11-7,14.9c0,4.3,3.5,7.8,7.9,7.8c4.3,0,7.9-3.5,7.9-7.8   C47.7,35.7,41.4,25.8,40.7,24.7z M39.8,45.4c-3.2,0-5.9-2.6-5.9-5.8c0-2.5,3.7-9,5.9-12.5c2.2,3.5,5.9,10,5.9,12.5   C45.7,42.8,43.1,45.4,39.8,45.4z"/></g></svg>
                    <a i18n><h3>Medical Device</h3></a>
                </div>
            </div>
        </div>
    </div>
    <div id="features"></div>
</section>

<br>
<section class="benefits-section box-container">
    <div class="benefits-container">
        <div class="benefits-grid">
            <div class="benefit-card1">
                <h4 i18n>How to Set Up MEDEIL Cloud HQ</h4>
                <p i18n>Getting started with MEDEIL Cloud HQ is simple. Our team will guide you through setup, integration, and staff training to ensure a smooth transition. Enjoy a hassle-free onboarding process and ongoing support as you centralize your POS and inventory management.</p>
            </div>
            <div class="benefit-card1">
                <h4 i18n>Customer Success with Cloud HQ</h4>
                <p i18n>Join leading retail and pharmacy chains that trust MEDEIL Cloud HQ for their multi-store POS needs. Read customer success stories and discover how centralized POS management has transformed their operations, improved efficiency, and driven business growth.</p>
            </div>
        </div>
    </div>
</section>
<br>


<section class="about section-padding" id="features">
    <div class="section-title gradient-text ">
        <h2 i18n>Key Features</h2>s
    </div>
    <div class="container">
        <div class="row">
            <div class="col-lg-10 col-12 ms-lg-auto mb-2 mb-lg-0">
                <nav>
                    <div class="nav nav-tabs" id="nav-tab" role="tablist">
                        <button i18n class="nav-link active" id="nav-intro-tab" data-bs-toggle="tab" data-bs-target="#nav-intro" type="button" role="tab" aria-controls="nav-intro" aria-selected="true">Centralized Management</button>

                        <button i18n class="nav-link" id="nav-profile-tab" data-bs-toggle="tab" data-bs-target="#nav-profile" type="button" role="tab" aria-controls="nav-profile" aria-selected="false">Multi-Store</button>

                        <button i18n class="nav-link" id="nav-faq-tab" data-bs-toggle="tab" data-bs-target="#nav-faq" type="button" role="tab" aria-controls="nav-faq" aria-selected="false">Security and Compliance</button>
                        <button i18n class="nav-link" id="nav-faq-data" data-bs-toggle="tab" data-bs-target="#nav-data" type="button" role="tab" aria-controls="nav-data" aria-selected="false">Flexibility and Scalability</button>
                    </div>
                </nav>
            </div>
            <div class="col-12">
                <div class="tab-content" id="nav-tabContent">
                    <div class="tab-pane fade show active" id="nav-intro" role="tabpanel" aria-labelledby="nav-intro-tab">
                        <div class="row">
                            <div class="col-lg-6 col-12 mb-lg-0 mb-4">
                                <img ngSrc="https://medeilpos.blob.core.windows.net/websiteimage/opticalchainstoresoftware - medeilcloud hq.png" class="img-fluid" alt="optical chain store software - medeilcloud hq" height="400" width="500" priority>
                            </div>

                            <div class="col-lg-5 col-12 m-auto">
                                <h3 i18n class="mb-3">Integrated Administration</h3>

                                    <p i18n>Administrators should be able to monitor and manage all pharmacy locations' activities from a single dashboard thanks to the software's centralized management features.</p>
                                    <p i18n>Managing user access, pricing, promotions, and inventory are all included in this.</p>
                            </div>
                        </div>
                    </div>
                    <div class="tab-pane fade" id="nav-profile" role="tabpanel" aria-labelledby="nav-profile-tab">
                        <div class="row">
                            <div class="col-lg-5 col-12 m-auto">
                                <h3 i18n class="mb-3">Multi-Store handle</h3>
                              <p i18n>In order to allow each pharmacy to function independently and to enable centralized management and communication between stores, the software should handle several pharmacy locations. </p>
                              <p i18n>This contains functions for coordinating inter-store operations, sharing patient records, and moving inventory between locations.</p>
                            </div>

                            <div class="col-lg-6 col-12 mt-lg-0 mt-4">
                                <img ngSrc="https://medeilpos.blob.core.windows.net/websiteimage/medeilcloud hq.png" class="img-fluid" alt="medical device software for chainstores medeilcloud hq"  height="400" width="500" priority>
                            </div>
                        </div>
                    </div>

                    <div class="tab-pane fade mb-4" id="nav-faq" role="tabpanel" aria-labelledby="nav-faq-tab">
                        <div class="row">
                            <div class="col-lg-6 col-12 mb-lg-0 mb-4 mt-4">
                                <img ngSrc="https://medeilpos.blob.core.windows.net/websiteimage/multi store software = medeilcloud hq.png" class="img-fluid" alt="multi store software medeilcloud hq"  height="400" width="500" priority>
                            </div>

                            <div class="col-lg-5 col-12 m-auto">
                                <h3 i18n class="mb-3">Risk Management and Regulatory Adherence</h3>

                              <p i18n>The software must give top priority to safeguarding patient information and adhering to HIPAA (Health Insurance Portability and Accountability Act) and other healthcare standards, such as WHO-DDD, WHO-ATC Coding, and WHO-ICD Standards.</p>
                              <p i18n>This covers audit trails, role-based access controls, encryption of sensitive data, and adherence to industry standards.</p>


                            </div>
                        </div>
                    </div>
                    <div class="tab-pane fade mb-4" id="nav-data" role="tabpanel" aria-labelledby="nav-faq-data">
                        <div class="row">
                            <div class="col-lg-6 col-12 mb-lg-0 mb-4 mt-4">
                                <img ngSrc="https://medeilpos.blob.core.windows.net/websiteimage/chainsoftware-medeilcloud hq.png" class="img-fluid" alt="chain software-medeilcloud hq"  height="400" width="500" priority>
                            </div>

                            <div class="col-lg-5 col-12 m-auto">
                                <h3 i18n class="mb-3">Adaptability and Growth Potential</h3>

                             <p i18n>
                                The software should be both adaptable and scalable to meet changing business and regulatory requirements as well as the drugstore chain's expansion.</p>
                                <p i18n>This features support for upcoming expansions, modifiable processes, and adjustable settings.</p>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

        </div>
    </div>
    <div id="faq"></div>
</section>


<section class="hosbay-section mb-4">

    <div class="container">
        <div class="cta-section">
            <h2 i18n>Get Started with MedeilCloud HQ</h2>

            <p i18n>Ready to transform your multi-store operations? Experience the full potential of MedeilCloud HQ and take your business to the next level.</p>
            <a i18n (click)="appointment('Medeil Cloud HQ-Free Demo')" class="cta-button">🚀 Request a Free Demo</a>
        </div>
    </div>
</section>
<div class="container">
    <div class="section-title gradient-text mt-4 mb-4" >

        <h2 i18n>Frequently Asked Questions</h2>
    </div>
    <div class="row pt-45">
        <div class="col-lg-6">
            <div class="faq-item">
                <h4 i18n>Q: What is software for chain pharmacies?</h4>
                <p i18n><strong>A:</strong>
                    A specialist software program created to address the particular requirements of pharmacy chains with numerous sites is called chain pharmacy software. It offers centralized management capabilities for managing all branches' operations, inventory, prescription processing, and patient care</p>
            </div>
        </div>

        <div class="col-lg-6">
            <div class="faq-item">
                <h4 i18n>Q: Which characteristics make up chain pharmacy software?</h4>
                <p i18n><strong>A:</strong>Features like centralized management, support for many stores, integrated point-of-sale systems, real-time inventory tracking, unified patient information, reporting and analytics, security and compliance, and scalability to meet the demands of pharmacy chains are commonplace in chain pharmacy software.</p>
            </div>
        </div>

        <div class="col-lg-6">
            <div class="faq-item">
                <h4 i18n>Q: How is efficiency increased by chain pharmacy software?</h4>
                <p i18n><strong>A:</strong>
                    Chain pharmacy software allows managers to optimize inventory levels, standardize procedures, make data-driven decisions, and expedite operations by offering centralized management and real-time access to data from all branches. This lowers operating expenses and increases efficiency throughout the chain.</p>
            </div>
        </div>

        <div class="col-lg-6">
            <div class="faq-item">
                <h4 i18n>Q: Does software for chain pharmacies have development potential?</h4>
                <p i18n><strong>A:</strong>Yes, software for chain pharmacies is made to grow with the pharmacy chain. In order to adapt to operational changes, future growth plans, and changing business requirements, it provides scalable features, adaptable workflows, and flexible deployment options.</p>
            </div>
        </div>
    </div>

</div>
<section class="benefits-section">
    <div class="benefits-container">
        <h3 i18n class="benefits-title">Benefits of Using MedeilCloud HQ</h3>
        <div class="benefits-grid">
            <div class="benefit-card">
                <div class="benefit-icon">
                    <i class="fas fa-chart-line"></i>
                </div>
                <h4 i18n>Improved Efficiency</h4>
                <p i18n>Automate routine tasks and reduce manual errors to save time and resources.</p>
            </div>
            <div class="benefit-card">
                <div class="benefit-icon">
                    <i class="fas fa-user-md"></i>
                </div>
                <h4 i18n>Enhanced Control</h4>
                <p i18n>Gain complete visibility and control over all your locations from a single dashboard.</p>
            </div>
            <div class="benefit-card">
                <div class="benefit-icon">
                    <i class="fas fa-dollar-sign"></i>
                </div>
                <h4 i18n>Scalability</h4>
                <p i18n>Easily scale your operations as your business grows, without the need for extensive hardware investments</p>
            </div>
        </div>
    </div>
</section>
<div class="application-area-two">
    <div class="container">
        <div class="row align-items-center">
            <div class="col-lg-8">
                <div class="application-content">
                    <div class="mapp-title">

                        <h2 i18n><strong>MedeilCloud HQ</strong> Your Pharmacy Companion</h2>
                        <p i18n>Streamline Your Pharmacy Operations Effortlessly</p>
                    </div>

                    <div class="application-btn">
                        <a href="#" class="application-play-btn">
                            <img src="assets/img/google-play.svg" alt="medeilcloud hq image" loading="lazy">
                            <div class="btn-content">
                                <span>ANDROID APP ON</span>
                                <h3>Google Play</h3>
                            </div>
                        </a>

                    </div>
                </div>
            </div>

            <div class="col-lg-4">
                <div class="application-img-two" >
                    <img ngSrc="https://medeilpos.blob.core.windows.net/websiteimage/posmobileimage.png" alt="pos mobile image" height="250" width="130" priority>
                </div>
                <div id="testimonials"></div>
            </div>
        </div>
    </div>
</div>

    <div class="container">
        <div class="section-title gradient-text mt-4 mb-4" >

            <h2 i18n>Testimonials</h2>
        </div>
        <div class="text-center">

            <h4 i18n>What Our <b>Clients Say</b></h4>
        </div>

        <div class="row pt-25">
            <div class="col-lg-6">
                <div class="testimonial-item testimonial-item-bg2">
                    <h3 i18n>Peter</h3>
                    <span i18n>IT Manager at Pharmacy</span>
                    <p i18n>Using MEDEILCloud HQ to manage our chain of pharmacies has been a game changer. Our productivity and efficiency have significantly increased as a result of the flawless integration across all of our sites.</p>
                    <ul class="rating">
                        <li><i class='bx bxs-star'></i></li>
                        <li><i class='bx bxs-star'></i></li>
                        <li><i class='bx bxs-star'></i></li>
                        <li><i class='bx bxs-star'></i></li>
                        <li><i class='bx bxs-star'></i></li>
                    </ul>

                </div>
            </div>

            <div class="col-lg-6">
                <div class="testimonial-item testimonial-item-bg2">
                    <h3 i18n>Thomas</h3>
                    <span i18n>Senior Pharmacist</span>
                    <p i18n>Since I've been using MEDEILCloud HQ for more than a year, it has fundamentally changed the way I work with our customer and inventory data. The extremely powerful reporting features have assisted us in making better selections</p>
                    <ul class="rating">
                        <li><i class='bx bxs-star'></i></li>
                        <li><i class='bx bxs-star'></i></li>
                        <li><i class='bx bxs-star'></i></li>
                        <li><i class='bx bxs-star'></i></li>
                        <li><i class='bx bxs-star'></i></li>
                    </ul>
                </div>
            </div>
        </div>
    </div>
    <div class="application-area-two1 mt-3 mb-3">
        <div class="container">
            <div class="row">

                <div class="col-lg-12">
                    <div class="application-content ">
                        <div class="mapp-title1">
                            <h2 i18n><strong>MedeilCloud HQ</strong> Brochure</h2>
                            <p i18n>Discover How MedeilCloud HQ Can Transform Your Pharmacy Operations</p>
                        </div>

                        <div class="application-btn">
                                <button i18n class="default-btn-trial" (click)="broucher('MedeilCloud HQ Brochure')" >
                                  View Brochure
                                </button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <ngx-smart-modal #myModal identifier="myModal1" [closable]="false">
        <div class="custom-modal">
            <button class="close-btn" (click)="closepopup()">X</button>
            <div class="modal-header">
                <h5 i18n class="modal-title" id="exampleModalLabel">Enquiry Form</h5>
            </div>
            <div class="modal-body">
             <form [formGroup]="enquiryForm">
               <div class="form-group">
                 <label i18n for="recipient-name" class="col-form-label"><strong>Name</strong><span class="star">*</span></label>
                 <input type="text" name="rec" class="form-control" id="recipient-name" formControlName="leadname" required>
               </div>
               <div class="form-group">
                 <label i18n for="message-text" class="col-form-label"><strong>Organisation</strong></label>
                 <input type="text" name="rec" class="form-control" id="recipient-name" formControlName="organizationname" required>
               </div>
               <div class="form-group">
                 <label i18n for="message-text" class="col-form-label"><strong>Email</strong><span class="star">*</span></label>
                 <input type="text" name="rec" class="form-control" id="recipient-name" formControlName="primaryemail" required>
                 <div *ngIf="enquiryForm.controls.primaryemail.invalid && (enquiryForm.controls.primaryemail.dirty || enquiryForm.controls.primaryemail.touched)">
                  <div i18n *ngIf="enquiryForm.controls.primaryemail.errors?.required" style="color: red;">Email is required.</div>
                  <div i18n *ngIf="enquiryForm.controls.primaryemail.errors?.pattern" style="color: red;">Invalid email format.</div>
                </div>
               </div>
               <div class="form-group">
                 <label i18n for="message-text" class="col-form-label"><strong>Country</strong></label>
                 <select class="form-control"  formControlName="countryname1" style="font-size: 13px;" (change)="countrychange()">
                  <option i18n select disabled value="0" >---Select Country---</option>
                  <option  value="{{ country[1] }}" *ngFor="let country of totalcountry">{{country[1]}}</option>
                </select>
               </div>
               <div class="form-group">
                 <label i18n for="message-text" class="col-form-label"><strong>Mobile</strong><span class="star">*</span></label>
                 <div class="row">
                   <div class="col-lg-3">
                     <input type="text" name="rec" readonly class="form-control mobile-field" [(ngModel)]="dialcode" id="recipient-name" formControlName="phonedialcode">
                   </div>
                   <div class="col-lg-9">
                     <input type="text" name="rec" class="form-control mobile-field" maxlength="15" id="recipient-name" formControlName="primaryphone"
                     autocomplete="off" oninput="this.value = this.value.replace(/[^0-9.]/g, '').replace(/(\..*)\./g, '$1')">
                   </div>
                 </div>
               </div>
               <div class="form-group">
                 <label i18n for="message-text" class="col-form-label"><strong>Description</strong></label>
                 <input type="text" name="rec" class="form-control" id="recipient-name" formControlName="address1">
               </div>
               <label i18n for="message-text" class="col-form-label captchalabel"><strong>Enter captcha</strong></label>
               <div class="input-group">
                  <input type="text" class="form-control ecaptcha" required formControlName="enteredcaptcha" required="required"
                   (change)="checkCaptcha()"/>
                  <input type="text" class="form-control gcaptcha" formControlName="generatedcaptcha" readonly
                  [(ngModel)]="captcha"/>
                  <i class="fa fa-arrows-rotate refresh" (click)="generatecaptcha()"></i>
                </div>
                <div *ngIf="ecaptcha">
                  <p style="color: red">{{ errorcaptcha }}</p>
                </div>
               <div class="form-group">

                     <label i18n class="container1 mt-3">I Accept Terms & Conditions & MEDEIL Privacy Policy – Your Data Security & Rights
                         <input type="checkbox" checked="checked" formControlName="checkbox">
                         <span class="checkmark"></span>
                     </label>
               </div>
              <div  align="center" *ngIf="showElementsave">
                <img height="100px" width="100px" src="https://medeilpos.blob.core.windows.net/posimage/loading.gif" alt="medeil gif" loading="lazy">
              </div>
               <div class="btn-group mt-3">
                 <button i18n type="button" class="enquiry-btn" (click)="savebroucher()">Submit</button>
               </div>
             </form>
           </div>
        </div>
    </ngx-smart-modal>
    <div class="row mb-3 mt-5" style="width: 100%;">
        <div class="col-lg-2">
            <div class="rating-section">
                <h6>Crowd Review</h6>
                <div class="rating-stars">
                  <div class="starrate">&#9733;</div>
                  <div class="starrate">&#9733;</div>
                  <div class="starrate">&#9733;</div>
                  <div class="starrate">&#9733;</div>
                  <div class="starrate">&#9734;</div>
                </div>
                <p>4.3/5.0</p>
              </div>
        </div>
        <div class="col-lg-2">
            <div class="rating-section">
                <h6>Google</h6>
                <div class="rating-stars">
                  <div class="starrate">&#9733;</div>
                  <div class="starrate">&#9733;</div>
                  <div class="starrate">&#9733;</div>
                  <div class="starrate">&#9733;</div>
                  <div class="starrate">&#9734;</div>
                </div>
                <p>4.8/5.0</p>
              </div>
        </div>
        <div class="col-lg-2">
            <div class="rating-section">
                <h6>Capterra</h6>
                <div class="rating-stars">
                  <div class="starrate">&#9733;</div>
                  <div class="starrate">&#9733;</div>
                  <div class="starrate">&#9733;</div>
                  <div class="starrate">&#9733;</div>
                  <div class="starrate">&#9734;</div>
                </div>
                <p>4.4/5.0</p>
              </div>
        </div>
        <div class="col-lg-2">
            <div class="rating-section">
                <h6>Software Suggest</h6>
                <div class="rating-stars">
                  <div class="starrate">&#9733;</div>
                  <div class="starrate">&#9733;</div>
                  <div class="starrate">&#9733;</div>
                  <div class="starrate">&#9733;</div>
                  <div class="starrate">&#9734;</div>
                </div>
                <p>4.7/5.0</p>
              </div>
        </div>
        <div class="col-lg-2">
            <div class="rating-section">
                <h6>G2 Crowd</h6>
                <div class="rating-stars">
                  <div class="starrate">&#9733;</div>
                  <div class="starrate">&#9733;</div>
                  <div class="starrate">&#9733;</div>
                  <div class="starrate">&#9733;</div>
                  <div class="starrate">&#9734;</div>
                </div>
                <p>4.1/5.0</p>
              </div>
        </div>
        <div class="col-lg-2">
            <div class="rating-section">
                <h6>Trust Radius</h6>
                <div class="rating-stars">
                  <div class="starrate">&#9733;</div>
                  <div class="starrate">&#9733;</div>
                  <div class="starrate">&#9733;</div>
                  <div class="starrate">&#9733;</div>
                  <div class="starrate">&#9734;</div>
                </div>
                <p>4.6/5.0</p>
              </div>
        </div>
    </div>
<app-footer-style-two></app-footer-style-two>
